import { PROPERTY_WEDDING_DRESS_ID, PROPERTY_RING } from '@constant'
// 页面类型
export const PAGE_TYPE = {
  home: 'home',
  reviewing: 'reviewing',
  reviewFailed: 'reviewFailed',
  order: 'order',
  draftBox: 'draftBox'
}

export const BEFORE_PUBLISH_MEAL_INFO = {
  [PROPERTY_WEDDING_DRESS_ID]: [
    {
      title: '套餐封面',
      content:
        '1张横图，1张竖图，横图至少1080*675像素，竖图至少526*702像素，图片大小不超过10MB，最佳比例横图16:9，竖图3:4'
    },
    {
      title: '套餐图片',
      content:
        '3～5张套餐图片，至少1080*1440像素，图片大小不超过10MB，最佳比例为3:4'
    },
    {
      title: '套餐内容',
      content: '发布套餐主要售卖的服务项目，包含服务项目名称和对应售价'
    },
    {
      title: '审核时间规则',
      content: '发布套餐之后，2个工作日内完成审核，非工作日不审核。'
    }
  ],
  [PROPERTY_RING]: [
    {
      title: '商品封面',
      content:
        '1张横图，1张方图，横图至少1080*675像素，方图至少540*540像素，图片大小不超过10MB，最佳比例横图16:9，方图1:1'
    },
    {
      title: '商品图片',
      content:
        '3～5张商品图片，至少1080*810像素，图片大小不超过10MB，最佳比例为4:3'
    },
    {
      title: '商品内容',
      content: '发布商品主要售卖的服务项目，包含服务项目名称和对应售价'
    },
    {
      title: '审核时间规则',
      content: '发布商品之后，2个工作日内完成审核，非工作日不审核。'
    }
  ],
  others: [
    {
      title: '套餐封面',
      content:
        '1张横图，1张方图，横图至少1080*675像素，方图至少540*540像素，图片大小不超过10MB，最佳比例横图16:9，方图1:1'
    },
    {
      title: '套餐图片',
      content:
        '3～5张套餐图片，至少1080*810像素，图片大小不超过10MB，最佳比例为4:3'
    },
    {
      title: '套餐内容',
      content: '发布套餐主要售卖的服务项目，包含服务项目名称和对应售价'
    },
    {
      title: '审核时间规则',
      content: '发布套餐之后，2个工作日内完成审核，非工作日不审核。'
    }
  ]
}
